import { useLocation } from 'react-router-dom';
import React, { createContext, useContext, useEffect, useState } from 'react';

const SidebarContext = createContext();

export const useSidebar = () => {
  const context = useContext(SidebarContext);
  if (!context) {
    throw new Error('useSidebar must be used within a SidebarProvider');
  }
  return context;
};

export const SidebarProvider = ({ children }) => {
  const { pathname } = useLocation();
  const isSalesPage = pathname.replace(/\/+$/, '') === '/orders/create';
  const [isDesktopSidebarOpen, setIsDesktopSidebarOpen] = useState(!isSalesPage);

  // Restore the sidebar when leaving sales, including browser back/forward navigation.
  useEffect(() => {
    setIsDesktopSidebarOpen(!isSalesPage);
  }, [pathname, isSalesPage]);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const value = {
    isDesktopSidebarOpen,
    setIsDesktopSidebarOpen,
    isMobileMenuOpen,
    setIsMobileMenuOpen,
  };

  return (
    <SidebarContext.Provider value={value}>
      {children}
    </SidebarContext.Provider>
  );
}; 